<template>
<section>
  <h2 class="text-3xl sm:text-4xl md:text-4xl  max-w-screen-lg pb-4 m:pb-8 mx-auto font-medium font-serif text-gray-800">Gallery</h2>
  <p class="text-md md:text-lg max-w-screen-md mx-auto text-gray-600 pb-4 px-4">Have a scroll through some of our latest creations shared on Instagram</p>
  <div class="gallery-container pb-12">
<iframe src="https://cdn.lightwidget.com/widgets/b65b885aa3ed560bb8f57d30203f696b.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:80%;border:0;"></iframe>
</div>

</section>
</template>

<script>

export default {
  name: 'SocialGallery',
   mounted() {
    // Dynamically add the script to load the LightWidget
    const script = document.createElement('script');
    script.src = "https://cdn.lightwidget.com/widgets/lightwidget.js";
    script.async = true;
    document.body.appendChild(script);
  }
}
</script>

<style scoped>
section {
  padding-top: 3rem;
}
.gallery-container {
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
 .lightwidget-widget {
  height: 500px;
}
}

</style>
